// The words of the team's Frame Stills panel (components/FrameStillsPanel.js), from GET /projects/{id}/frame-stills
// (backend app/frame_stills.state_for). One sentence: where the order and its stills stand.
const day = (iso) => (iso ? new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '');
const clock = (iso) => (iso ? new Date(iso).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) : '');

// The panel shows on a highlight film of a client Frame Stills are on for (the client's page), or on any film that
// already has an order (its money and its stills stay visible).
export const showsStills = (state) => !!state && (!!state.order || (!!state.on && !!state.eligible));

// Charge by hand only where her approval will not: a film approved before it was on. Before her approval, the approval
// charges her; a button there would charge her before she approved.
export const chargeable = (state) => !!state && !state.order && !!state.approved;

export function stillsLine(state) {
  const { order, job, price } = state || {};
  if (!order) {
    if (!state.approved) return `On for this client: $${price} is charged when she approves this film, and the stills follow.`;
    return `Approved before Frame Stills were on. One still from every clip, $${price}: her saved card, or a link to pay when she has none.`;
  }
  if (order.payment_status !== 'paid') {
    return `Waiting for her payment: link sent ${day(order.pay_link_sent_at)}${order.pay_link_reason ? ` (${order.pay_link_reason})` : ''}.`;
  }
  if (!job) return `Paid ${day(order.paid_at)}.`;
  if (job.state === 'made') {
    return `Made: ${(job.stills_count || 0).toLocaleString()} stills. They reach her film and her inbox after ${clock(job.release_at)}, an hour after she paid.`;
  }
  if (job.state === 'ready') return `Delivered ${day(job.delivered_at)}: ${(job.stills_count || 0).toLocaleString()} stills, beside the film.`;
  if (job.state === 'failed') return `Paid ${day(order.paid_at)}. The stills could not be made:`;
  return `Paid ${day(order.paid_at)}. ${job.words}.`;
}
